import { CssBaseline, GlobalStyles } from '@mui/material';

const BACKGROUND_COLOR = 'rgb(27, 21, 21)';
const FULL_HEIGHT = '100%';

const styles = {
  html: {
    backgroundColor: BACKGROUND_COLOR,
    height: FULL_HEIGHT,
  },
  body: {
    backgroundColor: BACKGROUND_COLOR,
    height: FULL_HEIGHT,
    '#root': {
      zIndex: 0,
      position: 'relative',
      height: FULL_HEIGHT,
      backgroundColor: BACKGROUND_COLOR,
    },
  },
};

const globalStylesNode = (
  <>
    <CssBaseline />
    <GlobalStyles styles={() => styles} />
  </>
);

export default globalStylesNode;
